import { render, staticRenderFns } from "./addboudDialog.vue?vue&type=template&id=01ccc926&scoped=true"
import script from "./addboudDialog.vue?vue&type=script&lang=js"
export * from "./addboudDialog.vue?vue&type=script&lang=js"
import style0 from "./addboudDialog.vue?vue&type=style&index=0&id=01ccc926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ccc926",
  null
  
)

export default component.exports